export type ChangeUserPasswordErrorCode =
    | 'UNKNOWN_USER'
    | 'PERMISSION_DENIED' // only the user can change it own password
    | 'INVALID_PASSWORD' // the current password is invalid
    | 'NEW_AND_CONFIRMATION_PASSWORD_DO_NOT_MATCH' // The new and confirmation password are not equal
    | 'PASSWORD_INSECURE' // the password don't have the necessary length/chars to be considered secure
    | 'PASSWORD_ALREADY_USED' // the password has already been used by the user
    | 'PASSWORD_CONTAINS_USER_DATA' // the password contains segments that match some user data (name / email)
    | 'UNKNOWN'; // self explanatory

export class ChangeUserPasswordError extends Error {
    code: ChangeUserPasswordErrorCode;
    constructor(code: ChangeUserPasswordErrorCode, message: string) {
        super(message);
        this.code = code;
    }
}
